import PlanDescription from './PlanDescription';

export default PlanDescription;
